import classNames from 'classnames';
import styles from './FJMobileCreationEdit.module.less';
import PropTypes from 'prop-types';
import { useRef, useMemo, useEffect, useCallback, useState } from 'react';
import { MOUSE_EVENT_TYPE } from '../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import { ZOOM_MIN_MOBILE, ZOOM_MAX, ZOOM_DOUBLE_RATE } from '../../../config/dataConfig/FJImageManipulationData';
import FJMobileCreationViewContainer from '../../FJMainPreview/FJMobileCreationView/FJMobileCreationViewContainer';
const FJMobileCreationEdit = props => {
    const {
        curBrushType,
        brushSize = 10,
        zoom = 1,
        isMouseMove,
        isShowBrushInCenter,
        initViewCanvas,
        mouseDownHandler,
        mouseUpHandler,
        mouseMoveHandler,
        isShowEditCanvas,
        setZoom,
        changeIsMouseMove,
        mobileCanDraw,
        containerHeight,
    } = props;

    const [mouseInPanel, setMouseInPanel] = useState(false);
    const [mousePoint, setMousePoint] = useState({ x: 0, y: 0 });
    const canvasRef = useRef(null);
    const distanceRef = useRef(0);
    useEffect(() => {
        // 移动端模糊问题(放大视图的画布)
        const scale = 2;
        const viewSize = {
            width: canvasRef.current.clientWidth * scale,
            height: canvasRef.current.clientHeight * scale,
        };

        canvasRef.current && initViewCanvas && initViewCanvas(canvasRef.current, viewSize);
    }, [initViewCanvas]);

    // 单指操作
    const _handleSingleTouchmove = useCallback(
        event => {
            if (!isShowEditCanvas || !mobileCanDraw) return;
            const canvasRefRect = canvasRef.current.getBoundingClientRect();
            setMousePoint({
                x: event.targetTouches[0].clientX - canvasRefRect.left,
                y: event.targetTouches[0].clientY - canvasRefRect.top,
            });
            mouseMoveHandler && mouseMoveHandler(event);
        },
        [isShowEditCanvas, mouseMoveHandler, mobileCanDraw],
    );
    const _handleSingleTouchend = useCallback(
        event => {
            if (!isShowEditCanvas || !mobileCanDraw) return;
            setMouseInPanel(false);
            mouseUpHandler && mouseUpHandler(event, false);
            document.removeEventListener('touchmove', _handleSingleTouchmove);
            document.removeEventListener('touchend', _handleSingleTouchend);
        },
        [isShowEditCanvas, mouseUpHandler, _handleSingleTouchmove, mobileCanDraw],
    );
    const _handleSingleTouchstart = useCallback(
        event => {
            if (!isShowEditCanvas || !mobileCanDraw) return;
            setMouseInPanel(true);
            const canvasRefRect = canvasRef.current.getBoundingClientRect();
            setMousePoint({
                x: event.targetTouches[0].clientX - canvasRefRect.left,
                y: event.targetTouches[0].clientY - canvasRefRect.top,
            });
            mouseDownHandler && mouseDownHandler(event);
            document.addEventListener('touchmove', _handleSingleTouchmove);
            document.addEventListener('touchend', _handleSingleTouchend);
        },
        [isShowEditCanvas, mouseDownHandler, _handleSingleTouchend, _handleSingleTouchmove, mobileCanDraw],
    );
    //双指操作
    const _handleDoubleTouchmove = useCallback(
        event => {
            event.preventDefault();
            if (!isShowEditCanvas) return;
            // 获取触摸点
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];
            const distance = Math.sqrt(
                Math.pow(touch2.clientX - touch1.clientX, 2) + Math.pow(touch2.clientY - touch1.clientY, 2),
            );
            const diff = Math.floor(distance - distanceRef.current) / ZOOM_DOUBLE_RATE;
            mouseMoveHandler && mouseMoveHandler(event);
            setZoom(Math.max(Math.min(zoom + diff, ZOOM_MAX), ZOOM_MIN_MOBILE), event);
        },
        [isShowEditCanvas, distanceRef, setZoom, zoom, mouseMoveHandler],
    );
    const _handleDoubleTouchend = useCallback(() => {
        if (!isShowEditCanvas) return;
        changeIsMouseMove(false);
        // mouseUpHandler && mouseUpHandler(event, false);

        document.removeEventListener('touchmove', _handleDoubleTouchmove);
        document.removeEventListener('touchend', _handleDoubleTouchend);
    }, [isShowEditCanvas, _handleDoubleTouchmove, changeIsMouseMove]);
    const _handleDoubleTouchstart = useCallback(
        event => {
            event.preventDefault();
            if (!isShowEditCanvas) return;
            // 获取触摸点
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];

            // 计算两个触摸点之间的距离
            distanceRef.current = Math.sqrt(
                Math.pow(touch2.clientX - touch1.clientX, 2) + Math.pow(touch2.clientY - touch1.clientY, 2),
            );
            changeIsMouseMove(true);
            mouseDownHandler && mouseDownHandler(event);

            document.addEventListener('touchmove', _handleDoubleTouchmove);
            document.addEventListener('touchend', _handleDoubleTouchend);
        },
        [isShowEditCanvas, _handleDoubleTouchmove, _handleDoubleTouchend, mouseDownHandler, changeIsMouseMove],
    );

    const _touchstart = useCallback(
        event => {
            // 获取触摸点
            const touches = event.touches;

            // 如果有两个触摸点，进行双指操作
            if (touches.length === 2) {
                event.preventDefault();
                setMouseInPanel(false);

                _handleDoubleTouchstart(event);
                document.removeEventListener('touchmove', _handleSingleTouchmove);
                document.removeEventListener('touchend', _handleSingleTouchend);
            } else if (touches.length === 1) {
                // 如果只有一个触摸点，进行单指操作
                _handleSingleTouchstart(event);
                document.removeEventListener('touchmove', _handleDoubleTouchmove);
                document.removeEventListener('touchend', _handleDoubleTouchend);
            } else if (touches.length === 0) {
                // 如果没有触摸点，进行空操作
                event.preventDefault();
                _handleSingleTouchend();
                _handleDoubleTouchend();

                return;
            }
        },
        [
            _handleSingleTouchstart,
            _handleDoubleTouchstart,
            _handleDoubleTouchmove,
            _handleDoubleTouchend,
            _handleSingleTouchmove,
            _handleSingleTouchend,
        ],
    );

    //#region UI 渲染方法
    const renderMouse = useMemo(() => {
        return (
            <div
                className={styles.mouse_point}
                style={{
                    top: !isShowBrushInCenter ? mousePoint.y : '48%',
                    left: !isShowBrushInCenter ? mousePoint.x : '50%',
                    width: brushSize * zoom,
                    height: brushSize * zoom,
                    display: !mouseInPanel && !isShowBrushInCenter ? 'none' : '',
                }}
            ></div>
        );
    }, [isShowBrushInCenter, mousePoint, brushSize, mouseInPanel, zoom]);
    const mouseStyleClass = useMemo(() => {
        return classNames({
            [styles.mouse_move]: isMouseMove,
            [styles.mouse_erase]: !isMouseMove && curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE,
            [styles.mouse_draw]: !isMouseMove && curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW,
        });
    }, [curBrushType, isMouseMove]);
    //#endregion
    return (
        <div
            className={classNames(styles.container, mouseStyleClass, { [styles.not_show_canvas]: !isShowEditCanvas })}
            onTouchStart={_touchstart}
            style={{ height: containerHeight }}
        >
            <canvas
                className={classNames(styles.canvas, { [styles.not_show_canvas]: !isShowEditCanvas })}
                ref={canvasRef}
            ></canvas>
            {!isShowEditCanvas && <FJMobileCreationViewContainer style={{ height: '100%' }} />}
            {renderMouse}
        </div>
    );
};
FJMobileCreationEdit.propTypes = {
    initViewCanvas: PropTypes.func,
    mouseDownHandler: PropTypes.func,
    mouseUpHandler: PropTypes.func,
    mouseMoveHandler: PropTypes.func,
    curBrushType: PropTypes.string,
    isMouseMove: PropTypes.bool,
    brushSize: PropTypes.number,
    zoom: PropTypes.number,
    isShowBrushInCenter: PropTypes.bool,
    setZoom: PropTypes.func,
    isShowEditCanvas: PropTypes.bool,
    changeIsMouseMove: PropTypes.func,
    mobileCanDraw: PropTypes.bool,
    containerHeight: PropTypes.string,
};
export default FJMobileCreationEdit;
